/**
 * Column definitions for reporting log tables.
 * Each function returns Ant Design Table columns based on months/quarters config.
 */

export const getMonthlyColumns = (months) => [
  {
    title: "",
    dataIndex: "type",
    key: "type",
    width: "15%",
  },
  ...months.map((month) => ({
    title: month,
    dataIndex: month,
    key: month,
  })),
  {
    title: "Year-to-Date (YTD)",
    dataIndex: "total",
    key: "total",
    render: (text, record) => record.total || 0,
  },
];

export const getQuarterColumns = (quarters) => [
  {
    title: "",
    dataIndex: "type",
    key: "type",
  },
  ...quarters.map((quarter) => ({
    title: quarter,
    dataIndex: quarter,
    key: quarter,
  })),
];

export const TWELVE_MONTHS_COLUMNS = [
  { title: "", dataIndex: "type", key: "type" },
  {
    title: "12 Months",
    dataIndex: "yearly",
    key: "yearly",
    width: "12%",
  },
];

export const YEAR_COLUMNS = [
  { title: "", dataIndex: "type", key: "type" },
  {
    title: "Yearly",
    dataIndex: "yearly",
    key: "yearly",
    width: "12%",
  },
];
